import styled from '@emotion/styled';

export const MainBlock = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 30px;

  height: 80px;
`;
